var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      {
        key: _vm.resetPagination,
        staticClass:
          "d-flex flex-row-reverse p-0 align-items-center justify-content-center list-style-none",
      },
      [
        _vm.displayNextPage || _vm.displayPreviousPage
          ? _c("li", [
              _c("p", { staticClass: "resultsTextPagination ml-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("common.results_desc") +
                      " " +
                      _vm.firstIndex +
                      " " +
                      _vm.$t("common.to") +
                      " " +
                      _vm.lastResultIndex
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.displayNextPage
          ? _c(
              "li",
              {
                staticClass: "p-2 pagination-button cursor",
                on: {
                  click: function ($event) {
                    return _vm.pagination(_vm.currentPage + 1)
                  },
                },
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.displayNextPage || _vm.displayPreviousPage
          ? _c(
              "li",
              { staticClass: "p-2 cursor" },
              [
                _vm.currentPage > 2
                  ? _c(
                      "span",
                      {
                        staticClass: "px-3 py-2 pagination-button",
                        on: {
                          click: function ($event) {
                            return _vm.pagination(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(1))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage > 3
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchPreviousPageInput,
                          expression: "searchPreviousPageInput",
                        },
                      ],
                      staticClass:
                        "mw-30px py-2 pagination-button text-center removeArrowsInput",
                      class: _vm.setClassPreviousPageInput,
                      attrs: {
                        placeholder: _vm.previousPageSearchInputSelected
                          ? ""
                          : "...",
                        type: "number",
                      },
                      domProps: { value: _vm.searchPreviousPageInput },
                      on: {
                        click: function ($event) {
                          _vm.previousPageSearchInputSelected = true
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.pagination(_vm.searchPreviousPageInput)
                        },
                        blur: function ($event) {
                          return _vm.pagination(_vm.searchPreviousPageInput)
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchPreviousPageInput = $event.target.value
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.previousPages, function (previousPage) {
                  return _c(
                    "span",
                    {
                      key: previousPage,
                      staticClass: "px-3 py-2 pagination-button",
                      on: {
                        click: function ($event) {
                          return _vm.pagination(previousPage)
                        },
                      },
                    },
                    [_vm._v(_vm._s(previousPage))]
                  )
                }),
                _vm._v(" "),
                _c("span", { staticClass: "pagination-button-active" }, [
                  _vm._v("\n          " + _vm._s(_vm.currentPage) + "\n      "),
                ]),
                _vm._v(" "),
                _vm._l(_vm.nextPages, function (nextPage) {
                  return _c(
                    "span",
                    {
                      key: nextPage + _vm.currentPage,
                      staticClass: "px-3 py-2 pagination-button",
                      on: {
                        click: function ($event) {
                          return _vm.pagination(nextPage + _vm.currentPage)
                        },
                      },
                    },
                    [_vm._v(_vm._s(nextPage + _vm.currentPage))]
                  )
                }),
                _vm._v(" "),
                _vm.allPages - _vm.currentPage > 2
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchNextPageInput,
                          expression: "searchNextPageInput",
                        },
                      ],
                      staticClass:
                        "mw-44px py-2 pagination-button text-center removeArrowsInput",
                      class: _vm.setClassNextPageInput,
                      attrs: {
                        placeholder: _vm.nextPageSearchInputSelected
                          ? ""
                          : "...",
                        type: "number",
                      },
                      domProps: { value: _vm.searchNextPageInput },
                      on: {
                        click: function ($event) {
                          _vm.nextPageSearchInputSelected = true
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.pagination(_vm.searchNextPageInput)
                        },
                        blur: function ($event) {
                          return _vm.pagination(_vm.searchNextPageInput)
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchNextPageInput = $event.target.value
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.allPages - _vm.currentPage > 1
                  ? _c(
                      "span",
                      {
                        staticClass: "px-3 py-2 pagination-button",
                        on: {
                          click: function ($event) {
                            return _vm.pagination(_vm.allPages)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.allPages))]
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.displayPreviousPage
          ? _c(
              "li",
              {
                staticClass: "p-2 pagination-button cursor",
                on: {
                  click: function ($event) {
                    return _vm.pagination(_vm.currentPage - 1)
                  },
                },
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }